import './icon.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import placeholder from '../../assets/icons/placeholder.svg'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    title?: string
    source?: string
    block?: boolean
    inline?: boolean
  }
>

const Icon = ({
  block = false,
  inline = false,
  className,
  title,
  source = placeholder,
  ...props
}: Props) => (
  <span
    className={cn('Icon', {block, inline}, className)}
    dangerouslySetInnerHTML={{__html: source}}
    aria-label={title}
    role={title ? 'img' : 'presentation'}
    {...props}
  />
)

export default Icon
